module.exports = __webpack_public_path__ + "img/seloMedalhaPrata.67766014.png";